module.exports = __webpack_public_path__ + "img/liweiguo.d40f4233.png";